<template>
    <section class="services">
        <Service v-for="(serviceOption, key) in serviceOptions" :service-option="serviceOption" :key="key" />
    </section>
</template>
<script>
import { mapGetters } from "vuex";
import Service from "./Service.vue";

export default {
    components: {
        Service,
    },
    computed: {
        ...mapGetters({
            serviceOptions: "orderService/getOrderServiceOptions",
        }),
    },
}
</script>
